import { isPatron, scrollToTop } from '../util/helpers'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
//import Ad from './Ad'
//import AlertDismissible from './AlertDismissable'
import AlternateArtModal from './AlternateArtModal'
import Clipboard from './Clipboard'
import ErrorBoundary from './ErrorBoundary'
import Footer from './Footer'
import GoogleAnalytics from './GoogleAnalytics'
import { Helmet } from 'react-helmet'
import Leaderboard from './Leaderboard'
import Navbar from './Navbar'
import { Outlet } from 'react-router-dom'
import ScrollToTopButton from './ScrollToTopButton'
import Toasts from './Toasts'
import classNames from 'classnames'
import { fetchMisc } from '../store/misc'
import styles from '../styles/Layout.module.scss'
import useDarkMode from 'use-dark-mode'
import { useEffect } from 'react'
import { useState } from 'react'

const Layout = () => {
  const darkMode = useDarkMode(false)
  const dispatch = useDispatch()
  const profile = useSelector((state) => state.firebase.profile)
  const location = useLocation()
  const history = useNavigate()
  const [prevLocation, setPrevLocation] = useState(location)

  useEffect(() => {
    dispatch(fetchMisc())
    scrollToTop()
  }, [])

  useEffect(() => {
    if (
      location.pathname !== prevLocation?.pathname ||
      location.search !== prevLocation?.search ||
      location.hash !== prevLocation?.hash
    ) {
      if (!location.state?.noTop) {
        scrollToTop()
      }
      dispatch({ history, location, prevLocation, type: 'LOCATION_CHANGE' })
    }
  }, [location])

  return (
    <div
      className={classNames(styles.containerOuter, {
        [styles.darkMode]: darkMode.value,
      })}
    >
      <div className={classNames(styles.container, styles.background)}>
        <ErrorBoundary>
          <AlternateArtModal />
        </ErrorBoundary>
        <ErrorBoundary>
          <Clipboard />
        </ErrorBoundary>
        <GoogleAnalytics />
        <ScrollToTopButton />
        <Toasts />
        <Navbar />
        <div className={styles.containerInner}>
          <ErrorBoundary>
            {/*<AlertDismissible />*/}
            {isPatron(profile) || (
              <>
                <Leaderboard />
                <Helmet>
                  <script
                    type='text/javascript'
                    async='async'
                    data-noptimize='1'
                    data-cfasync='false'
                    src='//scripts.mediavine.com/tags/edhrec.js'
                  ></script>
                </Helmet>
              </>
            )}
            <div className={classNames(styles.background)}>
              <div className={styles.layout}>
                <div className={styles.left}>
                  <Outlet />
                </div>
                {/* <Right /> */}
              </div>
            </div>
          </ErrorBoundary>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Layout
